
export class cAdminUserImage {
  mediaFrame: any;

  addButton = document.getElementById('c-image-id-add-button') as HTMLButtonElement;
  delButton = document.getElementById('c-image-id-del-button') as HTMLButtonElement;
  hidden    = document.getElementById('c-image-id')            as HTMLInputElement;
  image     = document.querySelector('.c-image-container')     as HTMLElement;

  constructor() {

    this.addButton.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.mediaFrame) {
        this.mediaFrame.open();
        return;
      }

      this.mediaFrame = wp.media({
        title    : 'Select Media',
        multiple : false,
        library  : {
          type   : 'image',
        }
      });
      this.mediaFrame.open();

      this.mediaFrame.on('select', () => {
        const attachment = this.mediaFrame.state().get('selection').first().toJSON();
        this.image.innerHTML = `<img src="${attachment.url}" alt="" style="max-width:100%;"/>`
        this.hidden.value = attachment.id;
      });
    });

    this.delButton.addEventListener('click', (e) => {
      this.image.innerHTML = '';
      this.hidden.value    = '0';
    });
  }

}